import { Component } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: 'svg-lot-filled-marker',
	template: `
		<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
			xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<defs></defs>
		<g id="Exports" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="icon-lot-filled" fill-rule="nonzero" fill="#000000">
				<g id="Icon-Lot-FILLED">
					<path d="M19.5,9.003 L18.108,9.003 C17.832,9.003 17.608,
						8.778 17.608,8.503 C17.608,8.226 17.832,8.003 18.108,
						8.003 L19.5,8.003 C19.776,8.003 20,8.226 20,8.503 C20,
						8.778 19.776,9.003 19.5,9.003 Z" id="Shape">
					</path>
					<path d="M16.37,4.112 C16.242,4.112 16.114,4.063 16.016,
						3.966 C15.821,3.772 15.821,3.454 16.016,3.259 L17.059,
						2.216 C17.254,2.021 17.571,2.021 17.766,2.216 C17.961,
						2.409 17.961,2.728 17.766,2.923 L16.723,3.966 C16.626,
						4.063 16.498,4.112 16.37,4.112 Z" id="Shape">
					</path>
					<path d="M11.5,2.394 C11.224,2.394 11,2.17 11,1.894 L11,
						0.503 C11,0.226 11.224,0.003 11.5,0.003 C11.776,0.003 12,
						0.226 12,0.503 L12,1.894 C12,2.17 11.776,2.394 11.5,2.394 Z"
						id="Shape">
					</path>
					<path d="M6.631,4.112 C6.503,4.112 6.375,4.063 6.277,
						3.966 L5.233,2.923 C5.038,2.728 5.038,2.411 5.233,
						2.216 C5.428,2.021 5.745,2.021 5.94,2.216 L6.984,
						3.259 C7.179,3.454 7.179,3.772 6.984,3.966 C6.887,
						4.063 6.759,4.112 6.631,4.112 Z" id="Shape">
					</path>
					<path d="M4.891,9.003 L3.5,9.003 C3.224,9.003 3,8.778 3,
						8.503 C3,8.226 3.224,8.003 3.5,8.003 L4.891,8.003 C5.168,
						8.003 5.391,8.226 5.391,8.503 C5.391,8.778 5.168,
						9.003 4.891,9.003 Z" id="Shape">
					</path>
					<path d="M11.555,11.358 C13.079,11.358 14.557,11.481 15.966,
						11.696 C16.621,10.782 17,9.677 17,8.503 C17,5.47 14.532,
						3.003 11.5,3.003 C8.467,3.003 6,5.47 6,8.503 C6,9.683 6.382,
						10.791 7.042,11.708 C8.483,11.485 9.997,11.358 11.555,11.358 Z"
						id="Shape">
					</path>
					<path d="M12.661,12.39 C12.441,12.38 12.222,12.374 12,
						12.372 L12,23.984 L16.266,23.984 L12.661,12.39 Z" id="Shape">
					</path>
					<path d="M6.733,23.983 L11,23.983 L11,12.374 C10.783,
						12.378 10.566,12.384 10.352,12.392 L6.733,23.983 Z" id="Shape">
					</path>
					<path d="M23,22.272 L23,15.483 C23,15.313 22.914,
						15.154 22.77,15.061 C20.825,13.813 18.129,12.958 15.096,
						12.581 L23,22.272 Z" id="Shape">
					</path>
					<path d="M9.2,12.725 L0.161,23.847 C0.25,23.931 0.368,
						23.984 0.5,23.984 L5.687,23.984 L9.2,12.725 Z" id="Shape">
					</path>
					<path d="M8.033,12.573 C4.961,12.95 2.22,13.806 0.233,
						15.059 C0.088,15.152 0,15.311 0,15.483 L0,22.46 L8.033,
						12.573 Z" id="Shape">
					</path>
					<path d="M13.745,12.508 L17.313,23.984 L22.5,23.984 C22.677,
						23.984 22.824,23.887 22.913,23.75 L13.745,12.508 Z" id="Shape">
					</path>
				</g>
			</g>
		</g>
	</svg>
    `,
})

export class SVGLotFilledMarkerComponent {

}
